module.exports = __webpack_public_path__ + "img/star-map-step_4.3eb387e.webp";